import { sendLocal, getPartnerId, exitPartnerMessage } from "@sinch/bus";
import { useAtom } from "jotai";
import { useEffect, type FC, useState, useCallback } from "react";
import { useIntl } from "react-intl";
import { useProfileContext } from "../../Profile/ProfileContext";
import { vendorConfigAtom } from "../../state/atoms";
import { HorizontalDivider } from "../elements/Dividers";
import { ExtendedProfileAvatar } from "./ProfileAvatar";
import { UsageInfo } from "./UsageInfo";
import { ProfileListButton } from "./components/ProfileListButton";
import { ProfileListItem } from "./components/ProfileListItem";
import { BooksIcon } from "./icons/BooksIcon";
import { SpeechBalloonIcon } from "./icons/SpeechBalloonIcon";
import { useZendeskWidget } from "./useZendeskWidget";

type ProfileContentProps = {
  onClose: () => void;
  logout: () => void;
};
export const ProfileContent: FC<ProfileContentProps> = ({
  onClose,
  logout,
}) => {
  const { name, usageInfo, isSupport, links } = useProfileContext();
  const [partnerId, setPartnerId] = useState<string | null>(null);
  const [vendorConfig] = useAtom(vendorConfigAtom);

  const intl = useIntl();
  const getSupportLink = () => {
    const vendorSupportLink = vendorConfig?.supportLink;
    if (
      vendorConfig?.isBrandStreetData ||
      vendorConfig?.isBrandMobiPost ||
      vendorConfig?.isBrandWholeSale ||
      !vendorSupportLink ||
      typeof vendorSupportLink !== "string"
    ) {
      return links.helpCenter;
    }
    return vendorSupportLink;
  };

  const { openWidget } = useZendeskWidget();
  const hasChatLink =
    vendorConfig?.isBrandMM ||
    vendorConfig?.isBrandSMSB ||
    vendorConfig?.isBrandTPG ||
    vendorConfig?.isBrandWholeSale ||
    vendorConfig?.isBrandDirectSMS ||
    vendorConfig?.isBrandMessageNet ||
    vendorConfig?.isBrandMobiPost ||
    vendorConfig?.isBrandSMSC ||
    vendorConfig?.isBrandStreetData ||
    false;

  const updatePartnerId = useCallback(
    async () => setPartnerId(await getPartnerId()),
    []
  );
  useEffect(() => {
    updatePartnerId();
  }, [updatePartnerId]);
  const exitPartner = async () => sendLocal(exitPartnerMessage(null));

  return (
    <>
      <ExtendedProfileAvatar name={name} onClick={onClose} />
      <UsageInfo usageInfo={usageInfo} />
      {isSupport && (
        <ProfileListItem
          hyperlink
          to={links.supportIndex}
          text={intl.formatMessage({ id: "menuItemProfileSupportDashboard" })}
        />
      )}
      {partnerId && (
        <ProfileListButton
          withSpacing
          onClick={exitPartner}
          text={intl.formatMessage({ id: "menuItemProfileBackToAccounts" })}
        />
      )}
      <HorizontalDivider margin="8px 0" />
      <ProfileListItem
        icon={<BooksIcon />}
        external
        to={getSupportLink()}
        text={intl.formatMessage({ id: "menuItemProfileHelpCenterItem" })}
      />
      {hasChatLink && (
        <ProfileListButton
          withSpacing
          icon={<SpeechBalloonIcon />}
          onClick={() => {
            openWidget();
            onClose();
          }}
          text={intl.formatMessage({
            id: "menuItemProfileChatWithSupportItem",
          })}
        />
      )}
      <HorizontalDivider margin="8px 0" />
      <ProfileListButton
        withSpacing
        onClick={() => {
          logout();
          onClose();
        }}
        text={intl.formatMessage({ id: "menuItemProfileLogoutItem" })}
      />
    </>
  );
};
